import axiosClient from './axiosClient';

export default {
  // Ricerca paginata con filtri

  // Dettaglio singolo record logprocesso
  trova: (id) => axiosClient.get(`/processi/${id}`),
};